import Fetch from "utils/fetch"

export const ObterLinhaProducaoPorCentro = (centro) => {
  return Fetch.get(`/unidadeNegocio/obterLinhaProducaoPorCentro/${centro}`).then(({data}) => data)
}

export const SalvarLinhasDeProducao = (linhasDeProducao, centro) => {
  return Fetch.post(`/unidadeNegocio/salvarLinhasDeProducao/${centro}`, linhasDeProducao).then(({data}) => data)
}
